import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';
 
class BlogsHome extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            
            loading : 1,
            blogs:this.props.blogs, 
        }
        

    }

    componentDidMount()
    {  
         
        if(this.props.blogs && this.state.loading === 1)
        {
             this.setState({loading:0}); 

              
        }
        
        
    }


    render()
    { 
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
          
    return (
        <div> 
  <section style={{backgroundColor:'#f3f4f6'}}>
        <div class="blog-summary">
         <div class="bs-header">
          <div class="bs-heading">
           NEWS &amp; UPDATES
          </div>
          <Link class="readmore2" to={base_url+`news`}>
           READ ARTICLES
          </Link>
         </div>
         <div class="bs-grid">
           {this.state.blogs.slice(0,4).map((item, index) => (
          <Link class="bs-item" data-aos="fade-up" data-aos-delay="500" to={base_url+'news-info/'+item.slug} style={{backgroundImage:'url('+item.image+')'}}>
           <div class="bs-container">
            <div class="bs-date">
             <div class="bs-month">
              {item.created_month}
             </div>
             <div class="bs-day">
              {item.created_date}
             </div>
            </div>
            <div class="bs-title">
             <div class="bs-headline">
              {item.title}
             </div>
             <div class="bs-subtitle">
              {item.subtitle}
             </div>
            </div>
           </div>
          </Link>

            ))}
          
         </div>
        </div>
       </section>
         
    

       </div>

    );
}

}

export default BlogsHome;